import Emitter from 'tiny-emitter'

const eventHub = new Emitter();
export default eventHub